import type Customer from "@acto/taskpane/core/domain/Customer";

/** The search result a customer was opened from, handed to the details page through navigation state. */
export interface OpenedSearchResult {
  matchFields: string[];
  position?: number;
}

/** The distinct search fields (e.g. `city`, `name`) the customer matched the active term on. */
export function searchMatchFields(customer: Customer): string[] {
  return [...new Set(customer.matchReasons?.map((reason) => reason.key) ?? [])];
}

/** How many of the customers matched on each search field; a customer matching two fields counts for both. */
export function countSearchMatchFields(customers: Customer[]): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const customer of customers) {
    for (const field of searchMatchFields(customer)) {
      counts[field] = (counts[field] ?? 0) + 1;
    }
  }
  return counts;
}
